import axios from "axios";
import React, { useEffect, useState } from "react";
import { showSuccess, showError } from "component/utils/SweetAlert";
import { useAuth } from "component/UseAuth";

const MenuForm = ({ mode, menuData, closeModal, onSuccess }) => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    menu_desc: "",   // Nama Menu
    menu_path: "",   // Path URL
    file_name: "",   // Nama file
    menu_type: "",   // Tipe menu (M/S)
    menu_root: "",   // ID root (0 jika menu utama)
    menu_icon: "",   // Icon (contoh: bx bx-user)
    brand_id: "",    // Brand ID
    entry_by: user?.name, // isi otomatis dari user login
  });

  useEffect(() => {
    if (mode === "edit" && menuData) {
      // isi form dengan data yang akan diedit
      setFormData((prev) => ({ ...prev, ...menuData }));
    } else {
      // reset form ke default kosong (mode tambah)
      setFormData({
        menu_desc: "",
        menu_path: "",
        file_name: "",
        menu_type: "",
        menu_root: "",
        menu_icon: "",
        brand_id: "",
        entry_by: user?.name,
      });
    }
  }, [mode, menuData, user]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Sesuaikan field yang dikirim ke backend (tabel MENU_SPMS)
    const formDataToSend = {
      menu_desc: formData.menu_desc,
      menu_path: formData.menu_path,
      file_name: formData.file_name,
      menu_type: formData.menu_type,
      menu_root: formData.menu_root || null,
      menu_icon: formData.menu_icon,
      brand_id: formData.brand_id,
      entry_by: formData.entry_by,
    };

    try {
      const response = await axios({
        method: mode === "add" ? "POST" : "PUT",
        url:
          mode === "add"
            ? `${process.env.REACT_APP_API}/menu`
            : `${process.env.REACT_APP_API}/menu/${menuData.menu_id}`,
        data: formDataToSend,
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200 || response.status === 201) {
        showSuccess(mode === "add" ? "Menu berhasil ditambahkan" : "Menu berhasil diperbarui");
        closeModal();
        if (onSuccess) onSuccess();
      } else {
        showError(mode === "add" ? "Gagal menambahkan menu" : "Gagal memperbarui Menu");
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menyimpan data.");
    }
  };

  return (        
    <>
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{mode === "add" ? "Tambah Menu" : "Edit Menu"}</h5>
          <button type="button" className="btn-close" onClick={closeModal}></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            {/* MENU_DESC */}
            <div className="form-group mb-3">
              <label htmlFor="menu_desc" className="form-label">Nama Menu</label>
              <input 
                className="form-control"
                type="text"
                name="menu_desc"
                placeholder="Isi Nama Menu"
                value={formData.menu_desc}
                onChange={handleChange}
                required
              />
            </div>

            {/* MENU_PATH */}
            <div className="form-group mb-3">
              <label htmlFor="menu_path" className="form-label">Path Menu</label>
              <input 
                className="form-control"
                type="text"
                name="menu_path"
                placeholder="/user, /bank, /category"
                value={formData.menu_path}
                onChange={handleChange}
                required
              />
            </div>

            {/* FILE_NAME */}
            <div className="form-group mb-3">
              <label htmlFor="file_name" className="form-label">File Name</label>
              <input 
                className="form-control"
                type="text"
                name="file_name"
                placeholder="Isi File Name"
                value={formData.file_name}
                onChange={handleChange}
              />
            </div>

            {/* MENU_TYPE */}
            <div className="form-group mb-3">
              <label htmlFor="menu_type" className="form-label">Tipe Menu</label>
              <select 
                className="form-select"
                name="menu_type"
                value={formData.menu_type}
                onChange={handleChange}
                required
              >
                <option value="" hidden>Pilih Tipe</option>
                <option value="M">Menu</option>
                <option value="S">Submenu</option>
              </select>
            </div>

            {/* MENU_ROOT */}
            <div className="form-group mb-3">
              <label htmlFor="menu_root" className="form-label">Root Menu</label>
              <input 
                className="form-control"
                type="number"
                name="menu_root"
                placeholder="Isi ID Root (0 jika menu utama)"
                value={formData.menu_root}
                onChange={handleChange}
              />
            </div>

            {/* MENU_ICON */}
            <div className="form-group mb-3">
              <label htmlFor="menu_icon" className="form-label">Icon Menu</label>
              <input 
                className="form-control"
                type="text"
                name="menu_icon"
                placeholder="contoh: bx bx-user-circle"
                value={formData.menu_icon}
                onChange={handleChange}
              />
            </div>

            {/* BRAND_ID */}
            <div className="form-group mb-3">
              <label htmlFor="brand_id" className="form-label">Brand ID</label>
              <input 
                className="form-control"
                type="text"
                name="brand_id"
                placeholder="Isi Brand ID"
                value={formData.brand_id}
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="btn btn-primary">
              {mode === "add" ? "Save" : "Update"}
            </button>
          </form>          
        </div>
      </div>
    </div>
    </>
  );
};

export default MenuForm;
